import { SelfURIMap } from './appTypings';

export const selfUri: SelfURIMap = {
  elisa: 'https://elisa-areena.staging.yle.fi',
  hbbtv: 'https://hbbtv-areena.staging.yle.fi',
  philips: 'https://philips-areena.staging.yle.fi',
  panasonic: 'https://panasonic-areena.staging.yle.fi',
  vestel: 'https://vestel-areena.staging.yle.fi',
  hisense: 'https://hisense-areena.staging.yle.fi',
  tivo: 'https://tivo-areena.staging.yle.fi',
  ps4: 'https://playstation4-areena.staging.yle.fi',
  ps5: 'https://playstation5-areena.staging.yle.fi',
  telia: 'https://telia-areena.staging.yle.fi',
  tizen: 'https://samsung-areena.staging.yle.fi',
  webos: 'https://lg-areena.staging.yle.fi',
};
